import { FC, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import {
  Alert,
  AlertColor,
  Box,
  Button,
  Chip,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material"
import { styled } from "@mui/material/styles"
import {
  attachmentModule,
  caseManagement,
  orderView,
  stageControl,
  stagingManager,
  toothMovement,
  viewControlInTreatment,
  viewEdit,
  wasmModule,
} from "@/gluelayer"
import { isEmpty } from "lodash"

import { useAppDispatch, useAppSelector, useDeepEffect } from "@/core/app/hooks"
import { UText } from "@/components/index"
import { RootState } from "@/core/app/store"
import { getStageDetailApi } from "../../../core/app/slices/order/orderThunkApi"
const BaseButton = styled(Button)({
  width: 34,
  height: 34,
  minWidth: 34,
  padding: 0,
  color: "rgba(0, 0, 0, 0.87)",
  border: "1px solid",
  borderRadius: 4,
})
let runStageListen
const SelectStage = () => {
  const { caseId, patientId } = useParams()
  const dispatch = useAppDispatch()
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)

  const getArch = (udesign_category) => {
    let caseArch = "both",
      UpperType = "A",
      LowerType = "A"

    if (!udesign_category) return caseArch
    UpperType = udesign_category.split("/")[0]

    LowerType = udesign_category.split("/")[1]

    if (UpperType.includes("--")) {
      caseArch = "lower"
    } else if (LowerType.includes("--")) {
      caseArch = "upper"
    }

    return { caseArch, UpperType, LowerType }
  }
  // get stageDetail
  useDeepEffect(() => {
    dispatch(getStageDetailApi({ caseId, patientId }))
  }, [])
  return (
    <>
      <Box id="stageBox">
        <Box sx={{ padding: "16px 0", marginTop: "20px" }}>
          <UText variant="h6">Select stages to print STL:</UText>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: 10,
              float: "right",
              height: "100%",
              color: "rgba(0, 0, 0, 0.87)",
              fontWeight: 500,
            }}
          >
            <Box
              sx={{
                height: 18,
                width: 18,
                backgroundColor: "#78909C",
                borderRadius: 0.5,
                margin: 1,
              }}
            ></Box>
            Printed in office
            <Box
              sx={{
                height: 18,
                width: 18,
                backgroundColor: "#03A9F4",
                borderRadius: 0.5,
                margin: 1,
              }}
            ></Box>
            Previously ordered
            <Box
              sx={{
                height: 18,
                width: 18,
                backgroundColor: "#4CAF50",
                borderRadius: 0.5,
                margin: 1,
              }}
            ></Box>
            Current order
          </Box>
        </Box>
        {/* <Box>
          {getArch(caseDetail.udesign_category).caseArch !== "lower" &&
             (
              <Box>
                {stageComponent(
                  true,
                  upperStage,
                  lowerStage,
                  retainers,
                  selectedStage,
                  attachment,
                )}
              </Box>
            )}
          {getArch(caseDetail.udesign_category).caseArch !== "upper" &&
             (
              <Box>
                {stageComponent(
                  false,
                  upperStage,
                  lowerStage,
                  retainers,
                  selectedStage,
                  attachment,
                )}
              </Box>
            )}
        </Box> */}
      </Box>
    </>
  )
}

export default SelectStage
